export class OtherKpFilter {

  constructor() { }
  dateAucFrom: string
  dateAucTo: string
  
  searchMainField: string
  amountPosition: number
  
  status: string
  kam: string
  region: string
  customer: string
  distributor: string

  aucAgreementStatus: string
  mnn: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/other-kp-filter.ts